export default __webpack_public_path__ + "static/media/srisaila.36eb4eb4.png";